module.exports = __webpack_public_path__ + "img/client.0e21ae37.svg";